import { Component, OnInit } from '@angular/core';
import { UntypedFormGroup, Validators, UntypedFormBuilder } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { AuthService } from '../../core/services/auth.service';
import { PasswordValidation } from '../../core/validators/passwords-match.validator';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-recover-pass-page',
  templateUrl: './recover-pass-page.component.html',
  styleUrls: ['./recover-pass-page.component.scss']
})
export class RecoverPassPageComponent implements OnInit {

  public recoverForm: UntypedFormGroup;
  public newPassForm: UntypedFormGroup;

  public submitAttempted = false;
  public loading = false;
  public errorMsg: string;
  public successMsg: string;

  constructor(
    private fb: UntypedFormBuilder,
    private authService: AuthService,
    private activatedRoute: ActivatedRoute,
    private translate: TranslateService) { }

  ngOnInit() {
    const resetData = this.activatedRoute.snapshot.queryParams;
    if (resetData.token) {
      this.generateNewPassForm(resetData.token);
    } else {
      this.generateRecoverForm();
    }
  }

  generateRecoverForm() {
    this.recoverForm = this.fb.group({
      'email': ['', [Validators.required, Validators.email]],
    });
  }

  generateNewPassForm(token = null) {
    this.newPassForm = this.fb.group({
      'token': [token],
      'password1': ['', [Validators.required, Validators.min(4)]],
      'password2': ['', []]
    }, {
      validator: PasswordValidation.MatchPassword
    });
  }

  sendRecoverEmail() {
    this.submitAttempted = true;
    this.errorMsg = null;
    if (!this.recoverForm.valid) {
      return false;
    }
    this.loading = true;
    const payload = {
      email: this.recoverForm.get('email').value,
    };

    this.authService.sendResetPasswordEmail(payload).subscribe(() => {
      this.successMsg = this.translate.instant('LANDING.recover-pass-page.emailSent');
      this.loading = false;
    }, err => {
      this.errorMsg = err.errMsg;
      this.loading = false;
    });
  }

  resetPass() {
    this.submitAttempted = true;
    this.errorMsg = null;

    if (!this.newPassForm.valid) {
      return false;
    }

    this.loading = true;
    const payload = {
      'new_password1': this.newPassForm.get('password1').value,
      'new_password2': this.newPassForm.get('password2').value,
      'token': this.newPassForm.get('token').value
    };

    this.authService.resetPassword(payload).subscribe(() => {
      this.successMsg = this.translate.instant('LANDING.recover-pass-page.passwordSuccess');
      this.loading = false;
    }, err => {
      this.errorMsg = err.errMsg;
      this.loading = false;
    });
  }

}
